export const ONLINE_PENDING_APPT_DELETE = "doctor/delete-appointment";
export const INSTANT_CONSULT = "doctor/delete-instant-consult";
export const CLINIC_PENDING_APPT = "clinic/v1/get-pending-appointments-rev2";

// CLINIC_PENDING_APPT will be used: based on clinic id we will identify
// status_filter --> all, failed, pending, success
